import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0c50643a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/style/flex.css?vue&type=style&index=0&id=0c50643a&scoped=true&lang=css&"
import style1 from "@/style/wrapper.css?vue&type=style&index=1&id=0c50643a&scoped=true&lang=css&"
import style2 from "./index.vue?vue&type=style&index=2&id=0c50643a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50643a",
  null
  
)

export default component.exports